require("core-js/modules/es.array.reduce.js");

!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports["embed-next"] = t() : e["embed-next"] = t();
}(this, function () {
  return function () {
    "use strict";

    var e = {
      27: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.FORM_BASE_URL = t.POPUP_SIZE = t.SLIDER_WIDTH = t.SLIDER_POSITION = t.SIDETAB_ATTRIBUTE = t.WIDGET_ATTRIBUTE = t.SLIDER_ATTRIBUTE = t.POPUP_ATTRIBUTE = t.POPOVER_ATTRIBUTE = void 0, t.POPOVER_ATTRIBUTE = "data-tf-popover", t.POPUP_ATTRIBUTE = "data-tf-popup", t.SLIDER_ATTRIBUTE = "data-tf-slider", t.WIDGET_ATTRIBUTE = "data-tf-widget", t.SIDETAB_ATTRIBUTE = "data-tf-sidetab", t.SLIDER_POSITION = "right", t.SLIDER_WIDTH = 800, t.POPUP_SIZE = 100, t.FORM_BASE_URL = "https://form.typeform.com";
      },
      528: function _(e, t, n) {
        var r = this && this.__assign || function () {
          return (r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }).apply(this, arguments);
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createPopover = void 0;

        var o = n(747),
            i = n(972),
            a = function a(e) {
          return !!e.parentNode;
        },
            c = function c(e, t) {
          var n = e.parentNode;
          n && (n.removeChild(e), n.appendChild(t));
        },
            u = {
          buttonColor: "#3a7685"
        },
            d = function d(e) {
          var t;
          null === (t = e.parentNode) || void 0 === t || t.removeChild(e);
        };

        t.createPopover = function (e, t) {
          void 0 === t && (t = {});

          var n,
              s,
              f,
              l = r(r({}, u), t),
              p = o.createIframe(e, "popover", l),
              m = ((n = document.createElement("div")).className = "typeform-popover", n),
              v = function () {
            var e = document.createElement("div");
            return e.className = "typeform-popover-wrapper", e.dataset.testid = "typeform-popover-wrapper", e;
          }(),
              y = (s = l.customIcon, (f = document.createElement("div")).className = "typeform-popover-button-icon", f.innerHTML = s ? "<img alt='popover trigger icon button' style='max-width: 32px; max-height:32px;' src='" + s + "'/>" : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"\n    xmlns="http://www.w3.org/2000/svg">\n      <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5\n    9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75\n    7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25\n    7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125\n    17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="white"></path>\n    </svg>', f.dataset.testid = "default-icon", f),
              b = function () {
            var e = document.createElement("div");
            e.className = "typeform-spinner";
            var t = document.createElement("div");
            return t.className = "typeform-popover-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
          }(),
              h = function () {
            var e = document.createElement("div");
            return e.className = "typeform-popover-button-icon", e.innerHTML = "&times;", e.dataset.testid = "close-icon", e;
          }(),
              O = function (e) {
            var t = document.createElement("button");
            return t.className = "typeform-popover-button", t.style.backgroundColor = e, t;
          }(l.buttonColor || u.buttonColor);

          (l.container || document.body).append(m), v.append(p), m.append(O), O.append(y), p.onload = function () {
            m.classList.add("open"), c(b, h);
          };

          var _ = function _() {
            a(v) || setTimeout(function () {
              m.append(v), v.style.opacity = "1", c(y, b);
            });
          },
              g = function g() {
            a(m) && setTimeout(function () {
              d(v), m.classList.remove("open"), c(h, y);
            }, 250);
          },
              w = function w() {
            a(v) ? g() : _();
          };

          return O.onclick = w, l.open && !a(v) && i.handleCustomOpen(_, l.open, l.openValue), {
            open: _,
            close: g,
            toggle: w,
            refresh: function refresh() {
              var e;
              null === (e = p.contentWindow) || void 0 === e || e.location.reload();
            },
            unmount: function unmount() {
              d(m);
            }
          };
        };
      },
      797: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(528), t);
      },
      630: function _(e, t, n) {
        var r = this && this.__rest || function (e, t) {
          var n = {};

          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }

          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;

            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
              t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
            }
          }

          return n;
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createPopup = void 0;

        var o = n(747),
            i = n(27),
            a = n(972),
            c = function c(e) {
          return !!e.parentNode;
        };

        t.createPopup = function (e, t) {
          if (void 0 === t && (t = {}), !o.hasDom()) return {
            open: function open() {},
            close: function close() {},
            toggle: function toggle() {},
            refresh: function refresh() {}
          };

          var n = t.width,
              u = t.height,
              d = t.size,
              s = void 0 === d ? i.POPUP_SIZE : d,
              f = r(t, ["width", "height", "size"]),
              l = o.createIframe(e, "popup", f),
              p = function () {
            var e = document.createElement("div");
            return e.className = "typeform-popup", e.style.opacity = "0", e;
          }(),
              m = function () {
            var e = document.createElement("div");
            return e.className = "typeform-spinner", e;
          }(),
              v = function (e, t, n) {
            var r = document.createElement("div");
            return r.className = "typeform-iframe-wrapper", r.style.opacity = "0", o.isDefined(e) && o.isDefined(t) ? (r.style.width = e + "px", r.style.height = t + "px") : (r.style.width = "calc(" + n + "% - 80px)", r.style.height = "calc(" + n + "% - 80px)"), r;
          }(n, u, s);

          v.append(l), p.append(m), p.append(v);
          var y = f.container || document.body;

          l.onload = function () {
            v.style.opacity = "1", setTimeout(function () {
              m.style.display = "none";
            }, 250);
          };

          var b = function b() {
            c(p) || (y.append(p), setTimeout(function () {
              p.style.opacity = "1";
            }));
          },
              h = function h() {
            c(p) && (p.style.opacity = "0", v.style.opacity = "0", setTimeout(function () {
              p.parentNode.removeChild(p), m.style.display = "block";
            }, 250));
          };

          return v.append(function (e) {
            var t = document.createElement("a");
            return t.className = "typeform-close", t.innerHTML = "&times;", t.onclick = e, t;
          }(h)), f.open && !c(p) && a.handleCustomOpen(b, f.open, f.openValue), {
            open: b,
            close: h,
            toggle: function toggle() {
              c(p) ? h() : b();
            },
            refresh: function refresh() {
              var e;
              null === (e = l.contentWindow) || void 0 === e || e.location.reload();
            }
          };
        };
      },
      970: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(630), t), o(n(394), t);
      },
      394: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
      },
      382: function _(e, t, n) {
        var r = this && this.__assign || function () {
          return (r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }).apply(this, arguments);
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createSidetab = void 0;

        var o = n(747),
            i = n(972),
            a = {
          buttonColor: "#3a7685",
          buttonText: "Launch me"
        },
            c = function c(e) {
          return !!e.parentNode;
        },
            u = function u(e, t) {
          var n = e.parentNode;
          n && (n.removeChild(e), n.appendChild(t));
        },
            d = function d(e) {
          var t;
          null === (t = e.parentNode) || void 0 === t || t.removeChild(e);
        };

        t.createSidetab = function (e, t) {
          void 0 === t && (t = {});

          var n,
              s,
              f,
              l,
              p = r(r({}, a), t),
              m = o.createIframe(e, "side-tab", p),
              v = ((n = document.createElement("div")).className = "typeform-sidetab", n),
              y = function () {
            var e = document.createElement("div");
            return e.className = "typeform-sidetab-wrapper", e.dataset.testid = "typeform-sidetab-wrapper", e;
          }(),
              b = function () {
            var e = document.createElement("div");
            e.className = "typeform-spinner";
            var t = document.createElement("div");
            return t.className = "typeform-sidetab-button-icon", t.dataset.testid = "spinner-icon", t.append(e), t;
          }(),
              h = function (e) {
            var t = document.createElement("button");
            return t.className = "typeform-sidetab-button", t.style.backgroundColor = e, t;
          }(p.buttonColor || a.buttonColor),
              O = function (e) {
            var t = document.createElement("span");
            return t.className = "typeform-sidetab-button-text", t.innerHTML = e, t;
          }(p.buttonText || a.buttonText),
              _ = (s = p.customIcon, (f = document.createElement("div")).className = "typeform-sidetab-button-icon", f.innerHTML = s ? "<img alt='sidetab trigger icon button' src='" + s + "'/>" : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n  <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="white"></path>\n</svg>', f.dataset.testid = "default-icon", f),
              g = ((l = document.createElement("div")).className = "typeform-sidetab-button-icon", l.innerHTML = "&times;", l.dataset.testid = "close-icon", l);

          document.body.append(v), y.append(m), v.append(h), h.append(_), h.append(O), setTimeout(function () {
            v.classList.add("ready");
          }, 250), m.onload = function () {
            v.classList.add("open"), u(b, g);
          };

          var w = function w() {
            c(y) || (v.append(y), u(_, b));
          },
              P = function P() {
            c(y) && setTimeout(function () {
              d(y), v.classList.remove("open"), u(g, _);
            }, 250);
          },
              j = function j() {
            c(y) ? P() : w();
          };

          return h.onclick = j, p.open && !c(y) && i.handleCustomOpen(w, p.open, p.openValue), {
            open: w,
            close: P,
            toggle: j,
            refresh: function refresh() {
              var e;
              null === (e = m.contentWindow) || void 0 === e || e.location.reload();
            },
            unmount: function unmount() {
              d(v);
            }
          };
        };
      },
      434: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(382), t);
      },
      603: function _(e, t, n) {
        var r = this && this.__rest || function (e, t) {
          var n = {};

          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }

          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;

            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
              t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
            }
          }

          return n;
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createSlider = void 0;

        var o = n(747),
            i = n(27),
            a = n(972),
            c = function c(e) {
          return !!e.parentNode;
        };

        t.createSlider = function (e, t) {
          if (void 0 === t && (t = {}), !o.hasDom()) return {
            open: function open() {},
            close: function close() {},
            toggle: function toggle() {},
            refresh: function refresh() {}
          };

          var n = t.position,
              u = void 0 === n ? i.SLIDER_POSITION : n,
              d = t.width,
              s = void 0 === d ? i.SLIDER_WIDTH : d,
              f = r(t, ["position", "width"]),
              l = o.createIframe(e, "slider", f),
              p = function (e) {
            var t = document.createElement("div");
            return t.className = "typeform-slider " + e, t.style.opacity = "0", t;
          }(u),
              m = function () {
            var e = document.createElement("div");
            return e.className = "typeform-spinner", e;
          }(),
              v = function (e, t) {
            var n = document.createElement("div");
            return n.className = "typeform-iframe-wrapper", n.style[e] = "-100%", n.style.width = t + "px", n;
          }(u, s);

          v.append(l), p.append(m), p.append(v);
          var y = f.container || document.body;

          l.onload = function () {
            v.style[u] = "0", setTimeout(function () {
              m.style.display = "none";
            }, 500);
          };

          var b = function b() {
            c(p) || (y.append(p), setTimeout(function () {
              p.style.opacity = "1";
            }));
          },
              h = function h() {
            c(p) && (p.style.opacity = "0", v.style[u] = "-100%", setTimeout(function () {
              p.parentNode.removeChild(p), m.style.display = "block";
            }, 500));
          };

          return v.append(function (e) {
            var t = document.createElement("a");
            return t.className = "typeform-close", t.innerHTML = "&times;", t.onclick = e, t;
          }(h)), f.open && !c(p) && a.handleCustomOpen(b, f.open, f.openValue), {
            open: b,
            close: h,
            toggle: function toggle() {
              c(p) ? h() : b();
            },
            refresh: function refresh() {
              var e;
              null === (e = l.contentWindow) || void 0 === e || e.location.reload();
            }
          };
        };
      },
      331: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(603), t), o(n(162), t);
      },
      162: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
      },
      718: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createWidget = void 0;
        var r = n(747),
            o = n(313);

        t.createWidget = function (e, t) {
          if (!r.hasDom()) return {
            refresh: function refresh() {}
          };
          var n = r.createIframe(e, "widget", t),
              i = o.buildWidget(n);
          return t.container.innerHTML = "", t.container.append(i), {
            refresh: function refresh() {
              var e;
              return null === (e = n.contentWindow) || void 0 === e ? void 0 : e.location.reload();
            }
          };
        };
      },
      419: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.buildWidget = void 0, t.buildWidget = function (e) {
          var t = document.createElement("div");
          return t.className = "typeform-widget", t.append(e), t;
        };
      },
      313: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(419), t);
      },
      321: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(718), t), o(n(58), t);
      },
      58: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
      },
      920: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(797), t), o(n(970), t), o(n(331), t), o(n(321), t), o(n(434), t);
      },
      626: function _(e, t, n) {
        var r = this && this.__assign || function () {
          return (r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }).apply(this, arguments);
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.buildIframeSrc = void 0;
        var o = n(27),
            i = n(527),
            a = n(346),
            c = n(698),
            u = {
          widget: "embed-widget",
          popup: "popup-blank",
          slider: "popup-drawer",
          popover: "popup-popover",
          "side-tab": "popup-side-panel"
        };

        t.buildIframeSrc = function (e) {
          var t = e.formId,
              n = e.type,
              d = e.embedId,
              s = e.options,
              f = function (e, t, n) {
            var o = c.getTransitiveSearchParams(n.transitiveSearchParams),
                i = {
              "typeform-embed-id": t,
              "typeform-embed": u[e],
              "typeform-source": n.source,
              "typeform-medium": n.medium,
              "typeform-medium-version": n.mediumVersion,
              "embed-hide-footer": n.hideFooter ? "true" : void 0,
              "embed-hide-headers": n.hideHeaders ? "true" : void 0,
              "embed-opacity": n.opacity,
              "disable-tracking": n.disableTracking ? "true" : void 0,
              "disable-auto-focus": n.disableAutoFocus ? "true" : void 0
            };
            return r(r({}, i), o);
          }(n, d, function (e) {
            return r(r({}, {
              source: null === (t = null === window || void 0 === window ? void 0 : window.location) || void 0 === t ? void 0 : t.hostname.replace(/^www\./, ""),
              medium: "embed-sdk",
              mediumVersion: "next"
            }), i.removeUndefinedKeys(e));
            var t;
          }(s)),
              l = function (e, t) {
            void 0 === t && (t = !1);
            var n = t ? "c" : "to";
            return new URL(o.FORM_BASE_URL + "/" + n + "/" + e);
          }(t, s.chat);

          if (Object.entries(f).filter(function (e) {
            var t = e[1];
            return a.isDefined(t);
          }).forEach(function (e) {
            var t = e[0],
                n = e[1];
            l.searchParams.set(t, n);
          }), s.hidden) {
            var p = new URL(o.FORM_BASE_URL);
            Object.entries(s.hidden).filter(function (e) {
              var t = e[1];
              return a.isDefined(t);
            }).forEach(function (e) {
              var t = e[0],
                  n = e[1];
              p.searchParams.set(t, n);
            });
            var m = p.searchParams.toString();
            m && (l.hash = m);
          }

          return l.href;
        };
      },
      972: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.handleCustomOpen = void 0, t.handleCustomOpen = function (e, t, n) {
          switch (t) {
            case "load":
              e();
              break;

            case "exit":
              n && function (e, t) {
                var n = 0,
                    r = function r(o) {
                  o.clientY < e && o.clientY < n ? (document.removeEventListener("mousemove", r), t()) : n = o.clientY;
                };

                document.addEventListener("mousemove", r);
              }(n, e);
              break;

            case "time":
              setTimeout(function () {
                e();
              }, n);
              break;

            case "scroll":
              n && function (e, t) {
                var n = function n() {
                  var r = window.pageYOffset || document.documentElement.scrollTop,
                      o = document.documentElement.clientTop || 0,
                      i = document.documentElement.scrollHeight,
                      a = r - o,
                      c = a / i * 100,
                      u = a + window.innerHeight >= i;
                  (c >= e || u) && (t(), document.removeEventListener("scroll", n));
                };

                document.addEventListener("scroll", n);
              }(n, e);
          }
        };
      },
      553: function _(e, t, n) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.createIframe = void 0;
        var r = n(626),
            o = n(866),
            i = n(554),
            a = n(256);

        t.createIframe = function (e, t, n) {
          var c = o.generateEmbedId(),
              u = r.buildIframeSrc({
            formId: e,
            embedId: c,
            type: t,
            options: n
          }),
              d = document.createElement("iframe");
          return d.src = u, d.dataset.testid = "iframe", d.addEventListener("load", a.triggerIframeRedraw, {
            once: !0
          }), window.addEventListener("message", i.getFormReadyHandler(c, n)), window.addEventListener("message", i.getFormQuestionChangedHandler(c, n)), window.addEventListener("message", i.getFormSubmitHandler(c, n)), d;
        };
      },
      866: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.generateEmbedId = void 0, t.generateEmbedId = function () {
          var e = Math.random();
          return String(e).split(".")[1];
        };
      },
      554: function _(e, t) {
        var n = this && this.__rest || function (e, t) {
          var n = {};

          for (var r in e) {
            Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
          }

          if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
            var o = 0;

            for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
              t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
            }
          }

          return n;
        };

        function r(e, t, r) {
          return function (o) {
            var i = o.data,
                a = i.type,
                c = i.embedId,
                u = n(i, ["type", "embedId"]);
            a === e && c === t && (null == r || r(u));
          };
        }

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getFormEventHandler = t.getFormSubmitHandler = t.getFormQuestionChangedHandler = t.getFormReadyHandler = void 0, t.getFormReadyHandler = function (e, t) {
          return r("form-ready", e, t.onReady);
        }, t.getFormQuestionChangedHandler = function (e, t) {
          return r("form-screen-changed", e, t.onQuestionChanged);
        }, t.getFormSubmitHandler = function (e, t) {
          return r("form-submit", e, t.onSubmit);
        }, t.getFormEventHandler = r;
      },
      339: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(553), t);
      },
      256: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.triggerIframeRedraw = void 0, t.triggerIframeRedraw = function () {
          this.style.transform = "translateZ(0)";
        };
      },
      698: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.getTransitiveSearchParams = void 0, t.getTransitiveSearchParams = function (e) {
          var t = new URL(window.location.href),
              n = {};
          return e && e.length > 0 && e.forEach(function (e) {
            t.searchParams.has(e) && (n[e] = t.searchParams.get(e));
          }), n;
        };
      },
      252: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.hasDom = void 0, t.hasDom = function () {
          return "undefined" != typeof document && "undefined" != typeof window;
        };
      },
      71: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.includeCss = void 0, t.includeCss = function (e) {
          var t = function (e) {
            return "https://embed.typeform.com/next/css/" + e;
          }(e);

          if (!document.querySelector('link[href="' + t + '"]')) {
            var n = document.createElement("link");
            n.rel = "stylesheet", n.href = t, document.head.append(n);
          }
        };
      },
      747: function _(e, t, n) {
        var r = this && this.__createBinding || (Object.create ? function (e, t, n, r) {
          void 0 === r && (r = n), Object.defineProperty(e, r, {
            enumerable: !0,
            get: function get() {
              return t[n];
            }
          });
        } : function (e, t, n, r) {
          void 0 === r && (r = n), e[r] = t[n];
        }),
            o = this && this.__exportStar || function (e, t) {
          for (var n in e) {
            "default" === n || Object.prototype.hasOwnProperty.call(t, n) || r(t, e, n);
          }
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), o(n(626), t), o(n(339), t), o(n(252), t), o(n(71), t), o(n(346), t), o(n(377), t), o(n(527), t);
      },
      346: function _(e, t) {
        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.isDefined = void 0, t.isDefined = function (e) {
          return null != e;
        };
      },
      377: function _(e, t) {
        var n = this && this.__assign || function () {
          return (n = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }).apply(this, arguments);
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.loadOptionsFromAttributes = t.transformAttributeValue = t.camelCaseToKebabCase = void 0, t.camelCaseToKebabCase = function (e) {
          return e.split("").map(function (e, t) {
            return e.toUpperCase() === e ? (0 !== t ? "-" : "") + e.toLowerCase() : e;
          }).join("");
        }, t.transformAttributeValue = function (e, t) {
          switch (t) {
            case "string":
              return function (e) {
                return e || void 0;
              }(e);

            case "boolean":
              return function (e) {
                return "" === e || "yes" === e || "true" === e;
              }(e);

            case "integer":
              return function (e) {
                var t = e ? parseInt(e, 10) : NaN;
                return isNaN(t) ? void 0 : t;
              }(e);

            case "function":
              return function (e) {
                var t = e && e in window ? window[e] : void 0;
                return "function" == typeof t ? t : void 0;
              }(e);

            case "array":
              return function (e) {
                if (e) return null == e ? void 0 : e.replace(/\s/g, "").split(",").filter(function (e) {
                  return !!e;
                });
              }(e);

            case "record":
              return function (e) {
                if (e) return e.split(",").filter(function (e) {
                  return !!e;
                }).reduce(function (e, t) {
                  var r,
                      o = t.match(/^([^=]+)=(.*)$/);

                  if (o) {
                    var i = o[1],
                        a = o[2];
                    return n(n({}, e), ((r = {})[i.trim()] = a, r));
                  }

                  return e;
                }, {});
              }(e);

            default:
              throw new Error("Invalid attribute transformation " + t);
          }
        }, t.loadOptionsFromAttributes = function (e, r) {
          return Object.keys(r).reduce(function (o, i) {
            var a;
            return n(n({}, o), ((a = {})[i] = t.transformAttributeValue(e.getAttribute("data-tf-" + t.camelCaseToKebabCase(i)), r[i]), a));
          }, {});
        };
      },
      527: function _(e, t, n) {
        var r = this && this.__assign || function () {
          return (r = Object.assign || function (e) {
            for (var t, n = 1, r = arguments.length; n < r; n++) {
              for (var o in t = arguments[n]) {
                Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              }
            }

            return e;
          }).apply(this, arguments);
        };

        Object.defineProperty(t, "__esModule", {
          value: !0
        }), t.removeUndefinedKeys = void 0;
        var o = n(346);

        t.removeUndefinedKeys = function (e) {
          return Object.entries(e).filter(function (e) {
            var t = e[1];
            return o.isDefined(t);
          }).reduce(function (e, t) {
            var n,
                o = t[0],
                i = t[1];
            return r(r({}, e), ((n = {})[o] = i, n));
          }, {});
        };
      }
    },
        t = {};
    return function n(r) {
      if (t[r]) return t[r].exports;
      var o = t[r] = {
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, n), o.exports;
    }(920);
  }();
});